import type { Tab } from '@/store/tabs/types.ts';

/**
 * regex that match default name given to tiles tab (tabType: 'tiles')
 */
const workspaceDefaultNameRegex = RegExp(/^Workspace \d*$/);

/**
 * check if the given string is a default name given for tiles tabs (tabType: 'tiles')
 */
const isDefaultTilesTabName = (name: string) => workspaceDefaultNameRegex.test(name);

/**
 * generate a new default name for a tiles tab (tabType: 'tiles')
 * @param tabs
 */
export const generateDefaultTilesTabName = (tabs: Tab[]): string => {
  const maxTabNb = tabs.reduce<number>((maxTabNb, tab) => {
    if (isDefaultTilesTabName(tab.tabName)) {
      const tabNb = Number.parseFloat(tab.tabName.match(/\d$|\d\d$/)?.[0] ?? '0');
      return tabNb > maxTabNb ? tabNb : maxTabNb;
    }
    return maxTabNb;
  }, 0);

  return `Workspace ${maxTabNb + 1}`;
};
